import React from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab({ openWhatsApp }) {
    const { pathname } = useLocation();
    if (/^\/(admin|learn|certificate|blueprint|bhajans?|video-course)/.test(pathname)) return null;
    return (
        <button
            onClick={() => openWhatsApp?.("launch")}
            data-testid="whatsapp-fab"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 left-6 z-[60] h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-xl hover:scale-105 transition-transform"
        >
            <MessageCircle className="h-7 w-7" />
        </button>
    );
}
